import React from 'react';

function LandingPage() {
  return (
    <div id="landing-page" style={{ marginTop: '100px' }}>
      <h1>Welcome to My Portfolio</h1>
      <p style={{ whiteSpace: 'pre-wrap' }}>
        {`这里是自我介绍。
        1
        1
        1
        1
        1
        1
        1
        1
        1
        1`}
      </p>
    </div>
  );
}

export default LandingPage;

  